<template>
  <div>Подключаемся к серверу</div>
</template>
